export enum AdPage {
  Feed = 'feed',
  Catalog = 'catalog',
  Messages = 'messages',
  NewMessage = 'new_message',
  ReplyMessage = 'reply_message',
  Item = 'item',
  FavoriteItems = 'favorite_items',
  Notifications = 'notifications',
  Unknown = 'unknown',
}

export enum VanFallbackReason {
  NoFill = 'no_fill',
  NetworkError = 'network_error',
}
